/** Runtime configuration. Vite inlines these values at build time. */

const DEFAULT_API_URL = 'http://localhost:8000';

/** Base URL of the API, never with a trailing slash. */
export const apiUrl = (import.meta.env.VITE_API_URL ?? DEFAULT_API_URL).replace(/\/+$/, '');
